import script from "./unloadAlert.vue?vue&type=script&lang=js"
export * from "./unloadAlert.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__